import { render, staticRenderFns } from "./OpenAmountsPerPerson.vue?vue&type=template&id=3a291dc3&"
import script from "./OpenAmountsPerPerson.vue?vue&type=script&lang=js&"
export * from "./OpenAmountsPerPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports